























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Base } from '@/components/common/base';
import { PaginationModel, VAction, VHeaders } from '@/models/pagedlistmodel';
import {
  AttachmentGridHeaders,
  AttachmentsFields,
  AttachmentModel,
  PartSaleDetail,
  CallLogHeaders,
  TextLogHeaders,
} from '@/models/fixedops/partsales';
import { AttachmentType } from '@/models/fixedops/attachment';
import { VFields } from '@/models/v-fields';
import { FileHelper } from '@/helper/file.helper';
import { IDialogOption } from '@/models/dialog';
import { FaxLine } from '@/models/admin/store';
import { StoreService } from '@/services/admin/store.service';
import {
  ConversationTypes,
  MetadataType,
  MetadataKeyIdentifier,
} from '@/enums/enums';
import { NewFaxViewModel } from '@/models/telephony/message';
import {attachmentTypeService,partSalesService,attachmentService,messageService,storeService} from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class PartSalesAttachmentPage extends Base {
  public pagination = new PaginationModel('invoiceNumber');
  public textPagination = new PaginationModel('createdDateTime', true);
  public callPagination = new PaginationModel('createdDateTime', true);

  public headers: VHeaders[] = [
          {
            align: 'left',
            sortable: true,
            text: this.$parent.$t('repairOrderAttachments.tabs.attachments.attachmentGrid.attachmentType') as string,
            value: 'attachmentTypeName',
          },
          {
              align: 'left',
              sortable: true,
              text: this.$parent.$t('repairOrderAttachments.tabs.attachments.attachmentGrid.uploadedAt') as string,
              value: 'createdAt',
              fieldType: 'date',
          },
          {
              align: 'left',
              sortable: true,
              text: this.$parent.$t('repairOrderAttachments.tabs.attachments.attachmentGrid.isPublic') as string,
              value: 'isPublic',
              fieldType: 'switch',
              onChange: (item) => {
                  this.toggleIsPublic(item);
              },
              disabled: (item: any): boolean => {
                return (
                  item.attachmentTypeName === "Square Reciept"
                );
              },
          },
          {
              align: 'center',
              isNotDataProp: true,
              text: this.$parent.$t('repairOrderAttachments.tabs.attachments.attachmentGrid.actions') as string,
              sortable: false,
          },
  ];
  public callLogHeaders: VHeaders[] = CallLogHeaders(this);
  public textLogHeaders: VHeaders[] = TextLogHeaders(this);

  public attachments: AttachmentModel[] = [];
  public callLogs: AttachmentModel[] = [];
  public textLogs: AttachmentModel[] = [];

  public actions: VAction[] = [];


  public loading: boolean = false;
  public submitLoading: boolean = false;
  public attachmentFields: Array<VFields<any>> = [];
  public attachmentTypes: AttachmentType[] = [];
  public attachmentModel: AttachmentModel = new AttachmentModel();
  public partSaleDetail: PartSaleDetail = new PartSaleDetail();
  public availableFaxNumbers: FaxLine[] = [];
  public invoiceNumber: string;
  public fileRef: any;
  public form: any = {};
  public selectedTab: string = null;
  public faxToSend: NewFaxViewModel = new NewFaxViewModel(
    ConversationTypes[ConversationTypes.Fax]
  );

  public showFaxDialog: IDialogOption = {
    width: 500,
    title: this.$parent.$t('partSalesAttachments.faxDialog.title') as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-paper-plane',
      text: this.$parent.$t('partSalesAttachments.faxDialog.btnSend') as string,
    },
    loading: false,
    onAction: (): void => {
      this.sendFax();
    },
  };

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.backToList();
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(
          false,
          this.$parent.$t('partSalesAttachments.alertFormIsInvalid') as string
        );
      }
      this.saveAttachment();
    }

    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t(
        'partSalesAttachments.btnBackToListTitle'
      ) as string,
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('partSalesAttachments.btnBackToList') as string,
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'partSales');

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.invoiceNumber = this.$route.params.invoiceNumber;
    this.attachmentFields = AttachmentsFields(this.onFileChange, this);
    this.attachmentModel.invoiceNumber = this.invoiceNumber;
    this.setActions();
    this.getAttachmentTypes();
    this.getAttachments();
    this.getAvailableFaxNumbers();
  }

  public setActions(): void {
    this.actions = [
      {
        type: 'button',
        icon: 'fa fa-eye',
        title: this.$parent.$t(
          'partSalesAttachments.tabs.attachments.attachmentGrid.gridActions.viewAttachment'
        ) as string,
        loading: false,
        action: (model, action: VAction) => {
          if (model.attachmentTypeName == "Square Reciept") {
            window.open(model.uri, "_blank");
          } else {
            this.viewAttachment(model.attachmentId, action);
          }
        },
      },
    ];
  }

  public async getAttachmentTypes(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.attachmentFields);
      const response = await attachmentTypeService.getAttachmentTypesListAsync();
      this.attachmentTypes = response.results;
      this.setAttachmentTypeItems('attachmentTypeId', this.attachmentTypes);
    } finally {
      this.formlyHideSkeleton(this.attachmentFields);
    }
  }

  public async getAttachments(): Promise<void> {
    try {
      this.loading = true;
      const response = await partSalesService.getPartSaleSquareReceipt(
        this.invoiceNumber
      );
      const attachments = response.results;
      this.callLogs = attachments.filter((r) => {
        return (
          r.attachmentTypeName === 'Voice Recording' ||
          r.attachmentTypeName === 'VoiceRecording'
        );
      });
      this.callPagination.totalItems = this.callLogs.length;

      this.textLogs = attachments.filter((r) => {
        return r.attachmentTypeName === 'Text';
      });
      this.textPagination.totalItems = this.textLogs.length;

      this.attachments = attachments.filter((r) => {
        return (
          r.attachmentTypeName !== 'Text' &&
          r.attachmentTypeName !== 'Voice Recording' &&
          r.attachmentTypeName !== 'Voice Transcription' &&
          r.attachmentTypeName !== 'VoiceRecording'
        );
      });
      this.pagination.totalItems = this.attachments.length;
    } finally {
      this.loading = false;
    }
  }

  public async saveAttachment(): Promise<void> {
    try {
      this.submitLoading = true;
      this.$emit('update:progress', this.submitLoading);
      await partSalesService.addAttachmentAsync(this.attachmentModel);
    } finally {
      this.submitLoading = false;
      this.$emit('update:progress', this.submitLoading);
    }

    this.showAlert(
      true,
      this.$t('partSalesAttachments.tabs.attachments.alertAttachmentUpdated')
    );
    this.attachmentModel.file = null;
    this.attachmentModel.attachmentTypeId = 0;
    this.attachmentModel.comment = '';
    if (this.fileRef) {
      this.fileRef.clear();
    }
    this.getAttachments();
  }

  public async getPartSalesDetail(): Promise<void> {
    try {
      const partSale = await partSalesService.getDetailAsync(
        this.invoiceNumber
      );
      if (partSale) {
        if (partSale.customer) {
          this.attachmentModel.customerName = partSale.customer.name;
        }
      }
    } finally {
      // this.hideLoader();
    }
  }

  public onFileChange(files, ref): void {
    if (files.length > 0) {
      this.fileRef = ref;
      // tslint:disable-next-line: max-line-length
      this.attachmentModel.fileExtension = files[0].file.name.substring(
        files[0].file.name.lastIndexOf('.')
      );
      FileHelper.getFileBytes(files[0].file, (base64) => {
        this.attachmentModel.file = base64;
      });
    }
  }

  public updatePaging(paging: PaginationModel): void {
    this.pagination = paging;
  }

  public updateCallLogPaging(paging: PaginationModel) {
    this.callPagination = paging;
  }

  public updateTextLogPaging(paging: PaginationModel) {
    this.textPagination = paging;
  }

  public backToList(): void {
    if (history.state && history.length > 1) {
      this.$router.back();
    } else {
      this.$router.push({
        name: 'app.partsales',
      });
    }
  }

  public setAttachmentTypeItems(fieldname: string, value: any[]) {
    const field = this.attachmentFields.find((m) => {
      return m.key === fieldname;
    });
    if (field) {
      field.templateOptions.items = value;
    }
  }

  public async viewAttachment(
    attachmentId: string,
    action: VAction
  ): Promise<void> {
    try {
      action.loading = true;
      await attachmentService.viewAttachmentAsync(attachmentId);
    } catch (e) {
      throw e;
    } finally {
      action.loading = false;
    }
  }

  public async sendFax(): Promise<void> {
    if (!this.faxToSend.from || this.faxToSend.from.trim() === '') {
      this.showAlert(
        false,
        this.$t('partSalesAttachments.faxDialog.alertFillValidFromFaxNumber')
      );
      return;
    }

    if (!this.faxToSend.to || this.faxToSend.to.trim() === '') {
      this.showAlert(
        false,
        this.$t('partSalesAttachments.faxDialog.alertFillValidToFaxNumber')
      );
      return;
    }

    try {
      this.showFaxDialog.loading = true;
      const response = await messageService.sendFax(this.faxToSend);
      this.showFaxDialog.model = false;
    } catch (e) {
      throw e;
    } finally {
      this.showFaxDialog.loading = false;
    }
    // TODO:
    this.showAlert(
      true,
      this.$t('partSalesAttachments.faxDialog.alertSendAttachment')
    );
  }

  public async getAvailableFaxNumbers(): Promise<void> {
    try {
      const response = await storeService.getFaxLines();
      this.availableFaxNumbers = response.results;
    } catch (e) {
      throw e;
    }
  }

  public toggleIsPublic(item: AttachmentModel): void {
    if (item.isPublic) {
      this.togglePublic(item.id.toString(), true);
    } else {
      this.togglePublic(item.id.toString(), false);
    }
  }

  public async togglePublic(id: string, status: boolean): Promise<void> {
    try {
      this.showLoader();
      await attachmentService.toggleIsPublicAsync(id, status);
      this.showAlert(
        true,
        this.$t('partSalesAttachments.alertAttachmentUpdated')
      );
    } catch (e) {
      throw e;
    } finally {
      this.hideLoader();
    }
  }
}
